.root {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.flexColumn {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
